import { Directive, Optional } from "@angular/core";
import { NzTableCellDirective } from "ng-zorro-antd/table";
import { UiTableStyleService } from "@webapp/ui/table/services/table-style.service";

@Directive({
  selector: "th:not(.ui-disable-th):not([mat-cell]), td:not(.ui-disable-td):not([mat-cell])",
})
export class UiTableCellDirective extends NzTableCellDirective {
  constructor(@Optional() uiTableStyleService: UiTableStyleService) {
    super(uiTableStyleService);
  }
}
